import React from 'react';
import { SpotlightCard } from './ui/spotlight-card';
import ProfileImageGlowing from './ProfileImageGlowing';

export default function ProfileSpotlightSection() {
  return (
    <SpotlightCard
      className="page-section"
      spotlightColor="rgba(99, 102, 241, 0.3)"
    >
      <div className="profile-section" style={{
        display: 'flex',
        alignItems: 'center',
        gap: '2rem',
        padding: 0,
        border: 'none',
        backgroundColor: 'transparent',
        boxShadow: 'none'
      }}>
        <ProfileImageGlowing
          src="img/Chuckles.png"
          alt="Chuckles the Clown"
        />
        <div className="profile-info">
          <h2>Chuckles the Clown</h2>
          <p className="profile-description">Select a time that works best for your schedule.</p>
        </div>
      </div>
    </SpotlightCard>
  );
}
